import { getQuestionsFromQuestionnaire } from "../questionnaires/getAnswerToQuestionWithId";
import { AnsweredQuestionWithId, DropdownOption, QuestionnaireData, QuestionnaireState } from "../questionnaires/model";
import { QuestionConfig } from "../questionnaires/questionnaireConfig";
import { ReportDetails } from "../reportsCommon/reportsCommon";

import { mhpTreatmentReportMasterConfig } from "./mhpTreatmentReportMasterConfig";

export const MHP_TREATMENT_REPORT_KEY = "MHP_TREATMENT_REPORT_KEY";

export const ReportSectionIds = {
    EmployeeDetails: "EmployeeDetails",
    ReferralDetails: "ReferralDetails",
    TreatmentReceived: "TreatmentReceived",
    Outcome: "Outcome",
    WorkStatus: "WorkStatus",
    QuestionnaireScores: "QuestionnaireScores",
    FurtherAdjustmentsRecommendations: "FurtherAdjustmentsRecommendations"
};

export const getQuestionConfig = (questionId: string): QuestionConfig => {
    return mhpTreatmentReportMasterConfig.find(c => c.id === questionId) || { id: questionId, disabled: true };
};

export interface MHPTreatmentReportDto extends MHPTreatmentReportDetails {
    data: QuestionnaireData;
    eTag: string;
    isDefaultCustomerType?: boolean;
    customerType?: string;
    reportChangesBlocked?: boolean;
    releaseReportComments?: string;
    approvalState?: string;
    isConsentWithdrawn?: boolean;
}

export interface MHPTreatmentReportModel extends MHPTreatmentReportDetails {
    questions: AnsweredQuestionWithId[];
    eTag: string;
    isDefaultCustomerType?: boolean;
    customerType?: string;
    isConsentWithdrawn?: boolean;
}

export const getMHPTreatmentReportModel = (questionnaire: QuestionnaireState): MHPTreatmentReportModel => {
    const questions = getQuestionsFromQuestionnaire(questionnaire);
    return {
        questions,
        eTag: questionnaire?.eTag,
        isDefaultCustomerType: questionnaire?.isDefaultCustomerType,
        customerType: questionnaire?.customerType,
        reportChangesBlocked: questionnaire?.reportChangesBlocked,
        releaseReportComments: questionnaire?.releaseReportComments,
        approvalState: questionnaire?.approvalState,
        isConsentWithdrawn: questionnaire?.isConsentWithdrawn
    };
};

export interface MHPTreatmentReportDetails extends ReportDetails { }

export enum WorkStatus {
    FullDuties = "FullDuties",
    RestrictedDuties = "RestrictedDuties",
    OffWork = "OffWork"
}

export const workStatusAtInitialAssessmentOptions: DropdownOption[] = [
    { text: "Full Duties", value: WorkStatus.FullDuties },
    { text: "Restricted Duties", value: WorkStatus.RestrictedDuties },
    { text: "Off Work", value: WorkStatus.OffWork }
];

export const workStatusAtDischargeOptions: DropdownOption[] = [
    { text: "Full Duties", value: WorkStatus.FullDuties },
    { text: "Restricted Duties", value: WorkStatus.RestrictedDuties },
    { text: "Off Work", value: WorkStatus.OffWork }
];

export const treatmentReceivedAnswerOptions = {
    DepressionManagement: "Depression Management",
    AnxietyManagement: "Anxiety Management",
    StressManagement: "Stress Management",
    DietaryAdvice: "Dietary Advice",
    ExerciseClasses: "Exercise Classes",
    RelaxationExercises: "Relaxation Exercises"
};

export const outcomeAnswerOptions = {
    Recovered: "Recovered",
    NoChange: "No Change",
    ImprovedButNotInClinicalRecovery: "Improved but not in clinical recovery",
    Worse: "Worse",
    DNA: "DNA",
    OnwardReferral: "Onward referral (counselling/IAPT services etc.)"
};
